import styled from "styled-components";

const RightContainerStyled = styled.div`
  transition: margin 0.3s ease-in-out;
  margin-left: 0;
  
  @media only screen and (min-width: ${props => props.theme.desktopSmall}) {

  }
`;

export default RightContainerStyled;